// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableFooter_footer__iH2Q2 {
  transition: all 0.3s ease-out;
  padding: 30px 10px;
  margin-block-end: 50px;
  /* position: absolute;
  border: 1px solid rgb(224, 224, 224);
  bottom: -52px;
  margin-inline-start: -1px !important;
  width: calc(100% + 2px) !important;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px; */
}
.TableFooter_paginationContainer__560tr {
  direction: ltr;
  display: flex;
  align-items: center;
  justify-content: center;
}
.TableFooter_selectDataLimitGrid__1Wy4P {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.TableFooter_selectDataLimitContainer__HV3cC {
  padding: 2px 8px;
  margin-left: 7px;
  border: 1px solid #6d6d6d;
  border-radius: 20px;
}
.TableFooter_selectDataLimitLabel__ED72G {
  font-size: 14px;
}
.TableFooter_dataLimitSelectInput__olec\\+ {
  border: none;
  color: #6d6d6d;
  cursor: pointer;
  background-color: transparent;
}
.TableFooter_dataLimitSelectInput__olec\\+ option {
  background-color: #f8fbff;
}
.TableFooter_dataLimitSelectInput__olec\\+:focus {
  border: none;
  outline: none;
}
.TableFooter_allRecordes__mX0oL {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #56514f;
  font-size: 14px;
}
/* @media all and (max-width: 900px) {
  .footer {
    height: 75px;
    bottom: -74px;
  }
} */
.TableFooter_newContainer__1ms4y {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 15px;
  row-gap: 15px;
  flex-wrap: wrap;
}
.TableFooter_newDataLimitSelectInput__V\\+7R5 {
  border: none;
  cursor: pointer;
  background-color: #f1f1f1;
  border-radius: 5px;
  outline: none;
  width: 46px;
  height: 32px;
  font-size: 16px;
  font-weight: 400;
  font-family: inherit;
  margin-inline-start: 4px;
  padding-inline: 4px;
}
.TableFooter_paginationBtn__tHpoX {
  transition: all 0.3s ease-out;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.TableFooter_rotateIcon__2UI5E {
  transform: rotate(180deg);
}
.TableFooter_newDisabledPagi__7hknG {
  color: #9d9d9d;
  fill: #9d9d9d;
  cursor: default;
}
.TableFooter_newEnabledPagi__CozoX {
  color: #000;
  fill: #000;
  cursor: pointer;
}
.TableFooter_newEnabledPagi__CozoX:hover {
  background-color: rgba(187, 187, 187, 0.301);
}
.TableFooter_newPagination__6kYo- {
  display: flex;
  align-items: center;
  justify-content: center;
}
.TableFooter_newTotalNum__aTfxg {
  /* width: 115px; */
  background-color: #f1f1f1;
  text-align: center;
  border-radius: 5px;
  padding: 2px 7px;
}
.TableFooter_ltrDir__IGYoZ {
  direction: ltr;
}

@media all and (max-width: 600px) {
  /* .footer {
    height: 118px;
    bottom: -117px;
  } */
  .TableFooter_selectDataLimitGrid__1Wy4P {
    justify-content: center;
    padding: 10px 0;
  }
  .TableFooter_allRecordes__mX0oL {
    justify-content: center;
  }
  .TableFooter_newContainer__1ms4y {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/NewTable/TableFooter/TableFooter.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB;;;;;;oCAMkC;AACpC;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;AACA;;;;;GAKG;AACH;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,UAAU;EACV,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;;;KAGG;EACH;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".footer {\r\n  transition: all 0.3s ease-out;\r\n  padding: 30px 10px;\r\n  margin-block-end: 50px;\r\n  /* position: absolute;\r\n  border: 1px solid rgb(224, 224, 224);\r\n  bottom: -52px;\r\n  margin-inline-start: -1px !important;\r\n  width: calc(100% + 2px) !important;\r\n  border-bottom-left-radius: 8px;\r\n  border-bottom-right-radius: 8px; */\r\n}\r\n.paginationContainer {\r\n  direction: ltr;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.selectDataLimitGrid {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n.selectDataLimitContainer {\r\n  padding: 2px 8px;\r\n  margin-left: 7px;\r\n  border: 1px solid #6d6d6d;\r\n  border-radius: 20px;\r\n}\r\n.selectDataLimitLabel {\r\n  font-size: 14px;\r\n}\r\n.dataLimitSelectInput {\r\n  border: none;\r\n  color: #6d6d6d;\r\n  cursor: pointer;\r\n  background-color: transparent;\r\n}\r\n.dataLimitSelectInput option {\r\n  background-color: #f8fbff;\r\n}\r\n.dataLimitSelectInput:focus {\r\n  border: none;\r\n  outline: none;\r\n}\r\n.allRecordes {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  color: #56514f;\r\n  font-size: 14px;\r\n}\r\n/* @media all and (max-width: 900px) {\r\n  .footer {\r\n    height: 75px;\r\n    bottom: -74px;\r\n  }\r\n} */\r\n.newContainer {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  column-gap: 15px;\r\n  row-gap: 15px;\r\n  flex-wrap: wrap;\r\n}\r\n.newDataLimitSelectInput {\r\n  border: none;\r\n  cursor: pointer;\r\n  background-color: #f1f1f1;\r\n  border-radius: 5px;\r\n  outline: none;\r\n  width: 46px;\r\n  height: 32px;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  font-family: inherit;\r\n  margin-inline-start: 4px;\r\n  padding-inline: 4px;\r\n}\r\n.paginationBtn {\r\n  transition: all 0.3s ease-out;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.rotateIcon {\r\n  transform: rotate(180deg);\r\n}\r\n.newDisabledPagi {\r\n  color: #9d9d9d;\r\n  fill: #9d9d9d;\r\n  cursor: default;\r\n}\r\n.newEnabledPagi {\r\n  color: #000;\r\n  fill: #000;\r\n  cursor: pointer;\r\n}\r\n.newEnabledPagi:hover {\r\n  background-color: rgba(187, 187, 187, 0.301);\r\n}\r\n.newPagination {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.newTotalNum {\r\n  /* width: 115px; */\r\n  background-color: #f1f1f1;\r\n  text-align: center;\r\n  border-radius: 5px;\r\n  padding: 2px 7px;\r\n}\r\n.ltrDir {\r\n  direction: ltr;\r\n}\r\n\r\n@media all and (max-width: 600px) {\r\n  /* .footer {\r\n    height: 118px;\r\n    bottom: -117px;\r\n  } */\r\n  .selectDataLimitGrid {\r\n    justify-content: center;\r\n    padding: 10px 0;\r\n  }\r\n  .allRecordes {\r\n    justify-content: center;\r\n  }\r\n  .newContainer {\r\n    justify-content: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `TableFooter_footer__iH2Q2`,
	"paginationContainer": `TableFooter_paginationContainer__560tr`,
	"selectDataLimitGrid": `TableFooter_selectDataLimitGrid__1Wy4P`,
	"selectDataLimitContainer": `TableFooter_selectDataLimitContainer__HV3cC`,
	"selectDataLimitLabel": `TableFooter_selectDataLimitLabel__ED72G`,
	"dataLimitSelectInput": `TableFooter_dataLimitSelectInput__olec+`,
	"allRecordes": `TableFooter_allRecordes__mX0oL`,
	"newContainer": `TableFooter_newContainer__1ms4y`,
	"newDataLimitSelectInput": `TableFooter_newDataLimitSelectInput__V+7R5`,
	"paginationBtn": `TableFooter_paginationBtn__tHpoX`,
	"rotateIcon": `TableFooter_rotateIcon__2UI5E`,
	"newDisabledPagi": `TableFooter_newDisabledPagi__7hknG`,
	"newEnabledPagi": `TableFooter_newEnabledPagi__CozoX`,
	"newPagination": `TableFooter_newPagination__6kYo-`,
	"newTotalNum": `TableFooter_newTotalNum__aTfxg`,
	"ltrDir": `TableFooter_ltrDir__IGYoZ`
};
export default ___CSS_LOADER_EXPORT___;
